import React, { useEffect, useRef, useState } from "react"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid'
import { getAreas, updateArea, deleteArea, addArea, searchGuild} from "../../store/goals/actions"
import SweetAlert from "react-bootstrap-sweetalert"
import Family from "../PlantList/family"
import { getProfile, editProfile } from "../../store/auth/profile/actions"

import {
  Card,
  CardTitle,
  CardText,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Progress,
  Row,
  TabContent,
  TabPane
} from "reactstrap"

import { StorageImage } from '@aws-amplify/ui-react-storage';
import { Storage } from '@aws-amplify/storage'
import { Image} from '@aws-amplify/ui-react'
import { Stage, Layer, Image as KImage, Star, Text, Rect } from 'react-konva';
import classnames from "classnames"
import { Link } from "react-router-dom"

import { getPlantData, getClimateData, saveClimateData, getCustomClimate } from "../../store/design/actions"
const Spline = require('cubic-spline');

// and then we will set it to native image instance when it is loaded
class URLImage extends React.Component {
  state = {
    image: null,
  };
  componentDidMount() {
    this.loadImage();
  }
  componentDidUpdate(oldProps) {
    if (oldProps.src !== this.props.src) {
      this.loadImage();
    }
  }
  componentWillUnmount() {
    this.image.removeEventListener('load', this.handleLoad);
  }

  async loadImage() {
      try {
          // Create an image object
          this.image = new window.Image();
          this.image.crossOrigin = "Anonymous"; // Handle CORS if needed
          this.image.src = this.props.src;

          this.image.addEventListener("load", this.handleLoad);
      } catch (error) {
          console.error("Error loading image from S3:", error);
      }
  }

  handleLoad = () => {
    // after setState react-konva will update canvas and redraw the layer
    // because "image" property is changed
    this.setState({
      image: this.image,
    });
    // if you keep same image object during source updates
    // you will have to update layer manually:
    // this.imageNode.getLayer().batchDraw();
  };
  render() {
    return (
      <KImage
        x={this.props.x}
        y={this.props.y}
        width={this.props.scale*75}
        height={this.props.scale*75}
        onClick={this.props.onSelect}
	      draggable
        image={this.state.image}
        ref={(node) => {
          this.imageNode = node;
        }}
      />
    );
  }
}

const BuildGuild = props => {
  var frame;
  
  const username = JSON.parse(localStorage.getItem("user")).user
  const { onGetClimateData, currArea, onUpdateArea, guildResults, area, onSearchGuild,
   plantData, plantDataMap, profile, userClimates, userareas, climateData, history, finishWizard, customplants } = props
  const [customClimate, setCustomClimate] = useState({})
  const [activeTab, setactiveTab] = useState(1)
  const [finishedArea, setFinishedArea] = useState(false)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  const [tab, setTab] = useState(1) 
  const [errors, setErrors] = useState({})
  const [progressValue, setprogressValue] = useState(5)
  const plantItem = {plant: "", qty: "", unit: ""};
  const [starPlayer, setStarPlayer] = useState()
  const [plants, setplants] = useState([])
  const [zone, setZone] = useState()
  const [guildName, setGuildName] = useState()
  const [climate, setClimate] = useState()
  const [layer, setLayer] = useState()
  const [plantFamilies, setPlantFamilies] = useState({})
  const [guildFunction, setGuildFunction] = useState()
  const [userGuildResults, setUserGuildResults] = useState([])
  const [zipcode, setZipcode] = useState("")
  const [coolSeason, setCoolSeason] = useState([])
  const [climateName, setClimateName] = useState()
  const [eventsCreated, setEventsCreated] = useState(false)
  const [areaPlantsCreated, setAreaPlantsCreated] = useState(false)
  const [warmSeason, setWarmSeason] = useState([])
  const [perennialSeason, setPerennialSeason] = useState([])
  const [plantWindows, setPlantWindow] = useState({})
  const [guildPlants, setGuildPlants] = useState([])
  const [customClimateModal, setCustomClimateModal] = useState(false)
  const [searchGuild, setSearchGuild] = useState(false)
  const [dragging, setDragging] = useState(false)
  const [imageX, setImageX] = useState(0)
  const [imageY, setImageY] = useState(0)
  const [showGuild, setShowGuild] = useState(false)
  const [currentShape, setCurrentShape] = useState()
  const dragUrl = useRef()
  const stageRef = useRef()
  const [images, setImages] = useState([])
  const [initiated, setInitiated] = useState()
  const [lastSearchParams, setLastSearchParams] = useState(null)
  const user = JSON.parse(localStorage.getItem("user")).user;

  var areasSync = []
  var palette = [
     "#FF1800", "#1C7500", "#0943BE", "#F8FE00"
  ]

  useEffect(() => {
    if (profile) {
        setZone(profile.USDAzone)
        setClimate(profile.climate)
    }
  }, [profile])

  useEffect(() => {
    const { onGetPlantData } = props
    onGetPlantData()
  }, [])

  useEffect(() => {
    const backendResults = (guildResults && guildResults.length > 0) ? guildResults : []
    const params = lastSearchParams
    let merged = [...backendResults]
    if (params && customplants && customplants.length > 0) {
      const fn = params.guildFunction
      const zn = params.zone
      const cl = params.climate
      const ly = params.layer
      const matching = customplants.filter(cp => {
        const fnMatch = fn === '*' || (Array.isArray(cp.guildFunction) && cp.guildFunction.includes(fn))
        const znMatch = zn === '*' || !zn || (cp.USDAMin != null && cp.USDAMax != null && parseInt(zn) >= cp.USDAMin && parseInt(zn) <= cp.USDAMax)
        const clMatch = cl === '*' || !cl || (Array.isArray(cp.climate) && cp.climate.includes(cl))
        const lyMatch = ly === '*' || !ly || (Array.isArray(cp.foodForestLayer) && cp.foodForestLayer.includes(ly))
        return fnMatch && znMatch && clMatch && lyMatch
      }).map(cp => ({
        name: cp.species,
        plant_family: cp.plantFamily,
        guildFunction: cp.guildFunction || [],
        foodForestLayer: cp.foodForestLayer || [],
        climate: cp.climate || [],
        USDAMin: cp.USDAMin,
        USDAMax: cp.USDAMax,
        size: cp.size,
        spacing_between_plants: cp.spacing_between_plants,
        yield_per_plant_ounces: cp.yieldPerPlant,
        cardIconKey: cp.cardIconKey,
        designerIconKey: cp.designerIconKey,
        isCustomPlant: true,
      }))
      merged = [...backendResults, ...matching].sort((a, b) => (a.name > b.name) ? 1 : -1)
    }
    setUserGuildResults(merged)
  }, [guildResults, customplants, lastSearchParams])

  function toggleSearch() {
      setSearchGuild(!searchGuild)
  }

  function generateColorFromPalette() {
      return palette[Math.floor(Math.random() * 4)];
  }

  const plantScales = {
            "tiny": 0.5,
            "small": 0.75,
            "medium": .75,
            "large": 1.5,
            "shrub": 2,
            "small tree": 3,
            "medium tree": 4,
            "large tree": 6
    }

  function addGuildPlant(plant) {
     let guildPlant = Object.assign({}, plant);
     guildPlant["totalHarvest"] = 0
     guildPlant["estHarvest"] = 0;
     let plants = [...guildPlants];
     plants.push(guildPlant);

     // recalc families
     var plantFamilies = {}
     for (var i=0; i<plants.length; i++) {
          plantFamilies[plants[i].plant_family] = "1"
     }
     plantFamilies[starPlayer.plant_family] = "1"
     setSearchGuild(false)
     setPlantFamilies(plantFamilies)
     setGuildPlants(plants)
  }

  function setName(name, index) {
     let fplants = [...plants];
     let item = {
         ...fplants[index],
         plant: name
     }
     fplants[index] = item
     setplants(fplants)
  }

  function setUnit(unit, index) {
     let fplants = [...plants];
     let item = {
         ...fplants[index],
         unit: unit
     }
     fplants[index] = item
     setplants(fplants)
  }

  function buildSearch() {
      setUserGuildResults([])
      setGuildFunction() 
      setLayer()
      setSearchGuild(true)
  }

  function buildFunctionSearch(guildfunc) {
      setUserGuildResults([])
      setGuildFunction(guildfunc)
      setLayer()
      setSearchGuild(true)
  }

  function buildLayerSearch(layer) {
      setUserGuildResults([])
      setGuildFunction()
      setLayer(layer)
      setSearchGuild(true)
  }

  function setQuantity(qty, index) {
     let fplants = [...plants];
     let item = {
         ...fplants[index],
         qty: qty
     }
     fplants[index] = item

     setplants(fplants);
  }

  function setZip (zip) {
     setZipcode(zip);
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
      }
    }
  }

   function searchStarPlayer() {
      var cl = climate?climate:'*'
      var zn = zone?zone:'*'
      var ly = layer?layer:'*'
      var fn = 'Star Player'
      var searchGuildParams = {
   guildFunction: fn,
         zone: zn,
   climate: cl,
   layer: ly
      }
      setLastSearchParams(searchGuildParams)
      onSearchGuild(searchGuildParams)
  }

  function selectShape(evt) {
     setCurrentShape(evt.currentTarget)
  }

   function deletePlant() {
     currentShape.destroy()
  }

    function removePlant(pindex) {
        var newGuildPlants = [...guildPlants]
        newGuildPlants.splice(pindex, 1);
        setGuildPlants(newGuildPlants)
  }


   function finishGuild() {
      var terrors = {
     }
     var failedValidation = false
     if (guildName==undefined || guildName=='') {
         terrors['guildName'] = "Guild Name is required"
         failedValidation = true
     }
     if (failedValidation) {
         setErrors(terrors)
         return
     }
      var finalGuild = {}

      var totals = {}
     for (var i in images) {
          if (totals[images[i].plant]) 
            totals[images[i].plant] += 1
          else 
            totals[images[i].plant] = 1
     }
     for (const plant in totals) {
          for (var j in guildPlants) {
              if (guildPlants[j].name == plant) 
                   guildPlants[j].numPlants = totals[plant]
          }
          if (starPlayer.name == plant)
              starPlayer.numPlants = totals[plant]
     }
     saveGuild()
     //setShowGuild(true)
  }

  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  function saveGuild () {
     var newPlants = [...currArea.plants]
     var newPlant = starPlayer
      newPlant["variety"] = ""
      var numPerSquareFoot = Math.pow(12/newPlant["spacing_between_plants"],2);
      newPlant["totalHarvest"] = 0
      newPlant["harvests"] = []
      newPlant["notes"] = []
      newPlant["guild"] = guildName
      newPlant["estHarvest"] = newPlant["yield_per_plant_ounces"] * newPlant.numPlants/16.0; 
      var numPerSquareFoot = Math.pow(12/newPlant["spacing_between_plants"],2);
      newPlant.spaceUsed = (newPlant.numPlants/numPerSquareFoot).toFixed(2);
      newPlant.species = newPlant.name;
      newPlants.push(newPlant);
      currArea["guilds"][guildName] = []
      currArea["guilds"][guildName].push(newPlant)
      for (var i=0; i<guildPlants.length; i++) {
           var newPlant = guildPlants[i]
           newPlant["variety"] = ""
          newPlant["totalHarvest"] = 0
          newPlant["harvests"] = []
          newPlant["notes"] = []
          newPlant["guild"] = guildName
          newPlant["estHarvest"] = newPlant["yield_per_plant_ounces"] * newPlant.numPlants/16.0; 
          numPerSquareFoot = Math.pow(12/newPlant["spacing_between_plants"],2);
           newPlant.spaceUsed = (newPlant.numPlants/numPerSquareFoot).toFixed(2);
           newPlant.species = newPlant.name;
           newPlants.push(newPlant);
           currArea["guilds"][guildName].push(newPlant)
      }
       currArea.plants = newPlants
      const dataUrl = stageRef.current.toDataURL();
      const blob = dataURLtoBlob(dataUrl);
      Storage.put(username+"-"+currArea.name + "-" + guildName, blob, {
               contentType: "image/png"
          }).then (result => {
               onUpdateArea (currArea)
               finishWizard()
             })
  }

  function submitSearch() {
      var cl = climate?climate:'*'
      var zn = zone?zone:'*'
      var ly = layer?layer:'*'
      var fn = guildFunction?guildFunction:'*'
      var searchGuildParams = {
           guildFunction: fn,
           zone: zn,
           climate: cl,
           layer: ly
      }
      setLastSearchParams(searchGuildParams)
      onSearchGuild(searchGuildParams)
  }

  function toggleTabProgress(tab) {
    if (activeTabProgress !== tab) {
        setprogressValue(20*(tab-1))
        setTab(tab)
        setactiveTabProgress(tab)
    }
  }

  return (
    <React.Fragment>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">{currArea.name}</h4>

                    <div id="progrss-wizard" className="twitter-bs-wizard">
                        <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTabProgress === 1
                                    })}
                                    onClick={() => {
                                        toggleTabProgress(1)
                                    }}
                                >
                                    <span className="step-number mr-2">1</span>
                                    <span>Choose Star Player</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTabProgress === 2
                                    })}
                                    onClick={() => {
                                        toggleTabProgress(2)
                                    }}
                                >
                                    <span className="step-number mr-2">2</span>
                                    <span>Add your Plants By Function</span>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTabProgress === 3
                                    })}
                                    onClick={() => {
                                        toggleTabProgress(3)
                                    }}
                                >
                                    <span className="step-number mr-2">3</span>
                                    Design your Vertical Space
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTabProgress === 4
                                    })}
                                    onClick={() => {
                                        toggleTabProgress(4)
                                    }}
                                >
                                    <span className="step-number mr-2">4</span>
                                    Check Diversity
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({
                                        active: activeTabProgress === 5
                                    })}
                                    onClick={() => {
                                        toggleTabProgress(5)
                                    }}
                                >
                                    <span className="step-number mr-2">5</span>
                                    Draw Your Guild
                                </NavLink>
                            </NavItem>
                        </ul>

                        <div id="bar" className="mt-4">
                            <Progress
                                color="success"
                                striped
                                animated
                                value={progressValue}
                            />
                            <div className="progress-bar bg-success progress-bar-striped progress-bar-animated"/>
                        </div>
                        <TabContent
                            activeTab={activeTabProgress}
                            className="twitter-bs-wizard-tab-content">
                            <TabPane tabId={1}>
                                <h4 className="mt-0 font-size-16">
                                    Choose Star Player
                                </h4>

                                <p>Pick your Star Player. This plant usually has the largest, most desirable harvest in
                                    your guild and is quite often a fruit tree.</p>
                                <Row>
                                    <Col md={3}><b>Climate</b></Col>
                                    <Col md={3}>
                                        <Input type="select" value={climate} onChange={event => {
                                            setClimate(event.target.value);
                                        }}>
                                            <option value="">All</option>
                                            <option value="Subtropical">Subtropical</option>
                                            <option value="Tropical">Tropical</option>
                                            <option value="Temperate">Temperate</option>
                                            <option value="Mediterranean">Mediterranean</option>
                                            <option value="Cold Desert">Cold Desert</option>
                                            <option value="Hot Desert">Hot Desert</option>
                                            <option value="Cool Temperate">Cool Temperate</option>
                                        </Input>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}><b>USDA Zone</b></Col>
                                    <Col md={3}>
                                        <Input type="select" value={zone} onChange={event => {
                                            setZone(event.target.value);
                                        }}>
                                            <option value=""></option>
                                            <option value="1">1a-1b</option>
                                            <option value="2">2a-2b</option>
                                            <option value="3">3a-3b</option>
                                            <option value="4">4a-4b</option>
                                            <option value="5">5a-5b</option>
                                            <option value="6">6a-6b</option>
                                            <option value="7">7a-7b</option>
                                            <option value="8">8a-8b</option>
                                            <option value="9">9a-9b</option>
                                            <option value="10">10a-10b</option>
                                            <option value="11">11a-11b</option>
                                            <option value="12">12a-12b</option>
                                        </Input>
                                    </Col>
                                </Row>


                                <Row style={{paddingTop: "10px", paddingBottom: "10px"}}>
                                    <Col md="4"/>
                                    <Col md="2">
                                        <Button
                                            onClick={e => {
                                                searchStarPlayer()
                                            }}
                                            color="success"
                                            className="btn-sm"
                                        >
                                            Search
                                        </Button>

                                    </Col>

                                </Row>
                                {starPlayer &&
                                    <Row>
                                        <Col md="4">
                                            Star Player Selected:
                                        </Col>
                                        <Col md="8">
                                            <h5>{starPlayer.name}</h5>
                                        </Col>
                                    </Row>
                                }

                                <div style={{width: "100%", height: "400px", overflowX: "hidden", overflowY: "scroll"}}>
                                    <Row>
                                        {!starPlayer && userGuildResults.map((plant) => (
                                            <Col md={3}>

                                                <Card outline color="secondary" className="border">
                                                    <CardBody style={{margin: "5px", padding: "2px", border: "2px"}}>
                                                        <Row>
                                                            <Col>
                                                                <StorageImage
                                                                    alt={plant.name}
                                                                    imgKey={plant.cardIconKey ? plant.cardIconKey : "card_icons/" + plant.name.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") + ".png"}
                                                                    accessLevel="guest"
                                                                    onStorageGetError={(error) => console.error(error)}
                                                                    style={{
                                                                        width: "100%",
                                                                        height: "auto",
                                                                        maxWidth: "324px",
                                                                        display: "block",
                                                                        margin: "auto"
                                                                    }}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={8}><i>{plant.name}</i></Col>
                                                            <Col md={3}>
                                                                <center><Button
                                                                    onClick={e => {
                                                                        setStarPlayer(plant)
                                                                    }}
                                                                    color="primary"
                                                                    className="btn-sm"
                                                                >
                                                                    Choose
                                                                </Button></center>
                                                            </Col>
                                                            <Col md={1}/>
                                                        </Row>
                                                        <Row>
                                                            <Col><b>Layer:</b> {plant.foodForestLayer}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col><b>Zone:</b> {plant.USDAMin} - {plant.USDAMax}</Col>
                                                        </Row>
                                                        <Row>
                                                            <Col><b>Climate:</b> {plant.climate.toString()}
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col><b>Functions:</b> {plant.guildFunction.toString()}
                                                            </Col>
                                                        </Row>


                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>

                            </TabPane>
                            <TabPane tabId={2}>
                                <h4 className="mt-0 font-size-16">
                                    Add your Plants By Function
                                </h4>
                                <p>
                                    Search for a plant to fill each of the supporting functions in a plant guild. You
                                    don't need to fill all the functions, but it's should try to fill at least 4 or 5 of
                                    these functions with plants. </p>


                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}>
                                                <Image className="img-fluid" style={{height: "40px"}}
                                                       src={"/pollinator.png"}/></Col>
                                            <Col md={3}>Pollinator/Insectary</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.guildFunction && plant.guildFunction.includes("Pollinator / Insectary")) {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <div>
                                                        <Row style={{marginBottom: "0px"}}>
                                                            <Card outline color="success" style={{marginBottom: "5px"}}
                                                                  className="border">
                                                                <CardTitle>
                                                                    {plant.name} <Button
                                                                    onClick={e => {
                                                                        removePlant(pindex)
                                                                    }}
                                                                    className="btn-sm"
                                                                >
                                                                    <i className="fas fa-trash-alt"/>
                                                                </Button>
                                                                </CardTitle>

                                                            </Card>
                                                        </Row>
                                                    </div>
                                                ))}
                                                <div onClick={e => {
                                                    buildFunctionSearch("Pollinator / Insectary")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         marginBottom: "8px",
                                                         width: "250px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/foodfiber.png"}/></Col>
                                            <Col md={3}>Food/Fiber</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.guildFunction && plant.guildFunction.includes("Food / Fiber")) {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <div>
                                                        <Row style={{marginBottom: "0px"}}>
                                                            <Card outline color="success" style={{marginBottom: "5px"}}
                                                                  className="border">
                                                                <CardTitle>
                                                                    {plant.name} <Button
                                                                    onClick={e => {
                                                                        removePlant(pindex)
                                                                    }}
                                                                    className="btn-sm"
                                                                >
                                                                    <i className="fas fa-trash-alt"/>
                                                                </Button>
                                                                </CardTitle>

                                                            </Card>
                                                        </Row>
                                                    </div>
                                                ))}
                                                <div onClick={e => {
                                                    buildFunctionSearch("Food / Fiber")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         marginBottom: "8px",
                                                         width: "250px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/windbreak.png"}/></Col>
                                            <Col md={3}>Windbreak/Privacy</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.guildFunction && plant.guildFunction.includes("Windbreak / Privacy")) {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <div>
                                                        <Row style={{marginBottom: "0px"}}>
                                                            <Card outline color="success" style={{marginBottom: "5px"}}
                                                                  className="border">
                                                                <CardTitle>
                                                                    {plant.name} <Button
                                                                    onClick={e => {
                                                                        removePlant(pindex)
                                                                    }}
                                                                    className="btn-sm"
                                                                >
                                                                    <i className="fas fa-trash-alt"/>
                                                                </Button>
                                                                </CardTitle>

                                                            </Card>
                                                        </Row>
                                                    </div>
                                                ))}
                                                <div onClick={e => {
                                                    buildFunctionSearch("Windbreak / Privacy")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         marginBottom: "8px",
                                                         width: "250px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/dynamic_accumulator.png"}/></Col>
                                            <Col md={3}>Dynamic Accumulator</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.guildFunction && plant.guildFunction.includes("Dynamic Accumulator")) {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                <div onClick={e => {
                                                    buildFunctionSearch("Dynamic Accumulator")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{width: "50px"}}
                                                               src={"/groundcover.png"}/></Col>
                                            <Col md={3}>Erosion Control</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.guildFunction && plant.guildFunction.includes("Erosion Control")) {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                <div onClick={e => {
                                                    buildFunctionSearch("Erosion Control")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{width: "50px"}}
                                                               src={"/nitrogen_fixer.png"}/></Col>
                                            <Col md={3}>Nitrogen Fixer</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.guildFunction && plant.guildFunction.includes("Nitrogen Fixer")) {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                <div onClick={e => {
                                                    buildFunctionSearch("Nitrogen Fixer")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{width: "50px"}}
                                                               src={"/medicinal.png"}/></Col>
                                            <Col md={3}>Medicinal</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.guildFunction && plant.guildFunction.includes("Medicinal Plants")) {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                <div onClick={e => {
                                                    buildFunctionSearch("Medicinal Plants")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId={3}>
                                <h4 className="mt-0 font-size-16">
                                    Design your Vertical Space
                                </h4>

                                <p>
                                    Check the different layers of a food forest your guild plants fill. Make sure the
                                    plants fill different layers so they can reach their full potential.
                                </p>

                                <Row>
                                    <Col md={2}></Col>
                                    <Col md={10}>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/canopytree.png"}/></Col>
                                            <Col md={3}>Canopy Tree</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.foodForestLayer && plant.foodForestLayer[0] == "Canopy") {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                {starPlayer && starPlayer.foodForestLayer == "Canopy" && <Row>
                                                    <Card outline color="success" style={{marginBottom: "5px"}}
                                                          className="border">
                                                        <CardTitle>
                                                            * {starPlayer.name}
                                                        </CardTitle>
                                                    </Card>
                                                </Row>
                                                }
                                                <div onClick={e => {
                                                    buildLayerSearch("Canopy")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/shadetree.png"}/></Col>
                                            <Col md={3}>Understory Tree</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.foodForestLayer && plant.foodForestLayer[0] == "Understory") {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                {starPlayer && starPlayer.foodForestLayer == "Understory" && <Row>
                                                    <Card outline color="success" style={{marginBottom: "5px"}}
                                                          className="border">
                                                        <CardTitle>
                                                            * {starPlayer.name}
                                                        </CardTitle>
                                                    </Card>
                                                </Row>
                                                }
                                                <div onClick={e => {
                                                    buildLayerSearch("Understory")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/shrub.png"}/></Col>
                                            <Col md={3}>Shrub/Bush</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.foodForestLayer && plant.foodForestLayer[0] == "shrub / Bush") {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                {starPlayer && starPlayer.foodForestLayer == "shrub / Bush" && <Row>
                                                    <Card outline color="success" style={{marginBottom: "5px"}}
                                                          className="border">
                                                        <CardTitle>
                                                            * {starPlayer.name}
                                                        </CardTitle>
                                                    </Card>
                                                </Row>
                                                }
                                                <div onClick={e => {
                                                    buildLayerSearch("shrub / Bush")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/herbaceous.png"}/></Col>
                                            <Col md={3}>Herbaceous</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.foodForestLayer && plant.foodForestLayer[0] == "Herbaceous") {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                {starPlayer && starPlayer.foodForestLayer == "Herbaceous" && <Row>
                                                    <Card outline color="success" style={{marginBottom: "5px"}}
                                                          className="border">
                                                        <CardTitle>
                                                            * {starPlayer.name}
                                                        </CardTitle>
                                                    </Card>
                                                </Row>
                                                }
                                                <div onClick={e => {
                                                    buildLayerSearch("Herbaceous")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/groundcover.png"}/></Col>
                                            <Col md={3}>Ground Cover</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.foodForestLayer && plant.foodForestLayer[0] == "Ground Cover") {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                {starPlayer && starPlayer.foodForestLayer == "Ground Cover" && <Row>
                                                    <Card outline color="success" style={{marginBottom: "5px"}}
                                                          className="border">
                                                        <CardTitle>
                                                            * {starPlayer.name}
                                                        </CardTitle>
                                                    </Card>
                                                </Row>
                                                }
                                                <div onClick={e => {
                                                    buildLayerSearch("Ground Cover")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/rootcrop.png"}/></Col>
                                            <Col md={3}>Root Crop</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.foodForestLayer && plant.foodForestLayer[0] == "Root Crop") {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                {starPlayer && starPlayer.foodForestLayer == "Root Crop" && <Row>
                                                    <Card outline color="success" style={{marginBottom: "5px"}}
                                                          className="border">
                                                        <CardTitle>
                                                            * {starPlayer.name}
                                                        </CardTitle>
                                                    </Card>
                                                </Row>
                                                }
                                                <div onClick={e => {
                                                    buildLayerSearch("Root Crop")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={2}><Image className="img-fluid" style={{height: "40px"}}
                                                               src={"/vining.png"}/></Col>
                                            <Col md={3}>Vining</Col>
                                            <Col md={6}>
                                                {guildPlants.filter(plant => {
                                                    if (plant.foodForestLayer && plant.foodForestLayer[0] == "Vining") {
                                                        return plant;
                                                    }
                                                }).map((plant, pindex) => (
                                                    <Row>
                                                        <Card outline color="success" style={{marginBottom: "5px"}}
                                                              className="border">
                                                            <CardTitle>
                                                                {plant.name} <Button
                                                                onClick={e => {
                                                                    removePlant(pindex)
                                                                }}
                                                                className="btn-sm"
                                                            >
                                                                <i className="fas fa-trash-alt"/>
                                                            </Button>
                                                            </CardTitle>
                                                        </Card>
                                                    </Row>
                                                ))}
                                                {starPlayer && starPlayer.foodForestLayer == "Vining" && <Row>
                                                    <Card outline color="success" style={{marginBottom: "5px"}}
                                                          className="border">
                                                        <CardTitle>
                                                            * {starPlayer.name}
                                                        </CardTitle>
                                                    </Card>
                                                </Row>
                                                }
                                                <div onClick={e => {
                                                    buildLayerSearch("Vining")
                                                }}
                                                     style={{
                                                         float: "left",
                                                         marginLeft: "-10px",
                                                         width: "250px",
                                                         marginBottom: "8px",
                                                         height: "30px",
                                                         backgroundColor: "#dddddd"
                                                     }}/>
                                            </Col>
                                        </Row>

                                    </Col>
                                </Row>

                            </TabPane>
                            <TabPane tabId={4}>
                                <h4 className="mt-0 font-size-16">
                                    Check Diversity
                                </h4>
                                <p>
                                    Make sure your plants are in different plant families to reduce your guild's risk of
                                    total failure
                                </p>
                                <div>
                                    <Row>
                                        {Object.keys(plantFamilies).map((family, findex) => (

                                            <Col md={3}>
                                                <Card style={{backgroundColor: "#738276"}}>
                                                    <CardBody style={{margin: "5px", padding: "2px", border: "2px"}}>
                                                        <CardTitle className="mb-4 text-white">
                                                            {family}
                                                        </CardTitle>
                                                        {guildPlants.filter(plant => {

                                                            if (plant.plant_family == family)
                                                                return plant;

                                                        }).map((plant, pindex) => (
                                                            <Card outline style={{
                                                                marginTop: "5px",
                                                                marginBottom: "0px",
                                                                padding: "2px",
                                                                border: "2px"
                                                            }} className="border">
                                                                <CardBody style={{
                                                                    marginTop: "0px",
                                                                    marginBottom: "0px",
                                                                    padding: "2px",
                                                                    border: "2px"
                                                                }}>
                                                                    <Row>
                                                                        <Col md={12}>
                                                                            <StorageImage
                                                                                alt={plant.name}
                                                                                imgKey={plant.cardIconKey ? plant.cardIconKey : "card_icons/" + plant.name.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") + ".png"}
                                                                                accessLevel="guest"
                                                                                onStorageGetError={(error) => console.error(error)}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "auto",
                                                                                    maxWidth: "324px",
                                                                                    display: "block",
                                                                                    margin: "auto"
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={12}
                                                                             style={{fontSize: ".9em"}}>{plant.name}</Col>
                                                                    </Row>

                                                                </CardBody>
                                                            </Card>
                                                        ))}
                                                        {starPlayer && starPlayer.plant_family == family &&
                                                            <Card outline style={{
                                                                marginTop: "5px",
                                                                marginBottom: "0px",
                                                                padding: "2px",
                                                                border: "2px"
                                                            }} className="border">
                                                                <CardBody style={{
                                                                    marginTop: "0px",
                                                                    marginBottom: "0px",
                                                                    padding: "2px",
                                                                    border: "2px"
                                                                }}>
                                                                    <Row>
                                                                        <Col md={12}>
                                                                            <StorageImage
                                                                                alt={starPlayer.name}
                                                                                imgKey={starPlayer.cardIconKey ? starPlayer.cardIconKey : "card_icons/" + starPlayer.name.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") + ".png"}
                                                                                accessLevel="guest"
                                                                                onStorageGetError={(error) => console.error(error)}
                                                                                style={{
                                                                                    width: "100%",
                                                                                    height: "auto",
                                                                                    maxWidth: "324px",
                                                                                    display: "block",
                                                                                    margin: "auto"
                                                                                }}
                                                                            />
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                        <Col md={12}
                                                                             style={{fontSize: ".9em"}}>{starPlayer.name}</Col>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>

                                                        }
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </TabPane>
                            <TabPane tabId={5}>
                                <h4 className="mt-0 font-size-16">
                                    Draw Your Guild
                                </h4>
                                <p>In this top view, drag your plants into your guild and arrange them how you'd like to
                                    group them.
                                </p>
                                <Row>
                                    <Col md={9}>
                                        <div
                                            onDrop={(e) => {
                                                e.preventDefault();

                                                if (!stageRef.current) {
                                                    console.error("Stage reference is not set!");
                                                    return;
                                                }

                                                // register event position
                                                stageRef.current.setPointersPositions(e);

                                                const pointerPos = stageRef.current.getPointerPosition();
                                                if (!pointerPos) {
                                                    console.error("Pointer position is null!");
                                                    return;
                                                }

                                                if (!dragUrl.current) {
                                                    console.error("dragUrl.current is undefined!"); // 🔍 Debugging check
                                                    return;
                                                }

                                                const scale = isNaN(dragUrl.scale) ? 1 : dragUrl.scale;

                                                const newImage = {
                                                    id: `img-${Date.now()}`,
                                                    x: pointerPos.x - 37 * scale,
                                                    y: pointerPos.y - 37 * scale,
                                                    scale: scale,
                                                    src: dragUrl.current, // ✅ Signed URL is now available
                                                    plant: dragUrl.plant,
                                                };

                                                setImages((prevImages) => [...prevImages, newImage]);

                                                console.log("Dropped image:", newImage);
                                            }}
                                            onDragOver={(e) => e.preventDefault()}
                                        >

                                        <Stage width="800" height="500" style={{border: '1px solid grey'}}
                                               ref={stageRef}
                                        >
                                            <Layer>
                                                {images.map((image) => {
                                                    return <URLImage src={image.src} x={image.x} y={image.y}
                                                                     onSelect={selectShape} scale={image.scale}/>;
                                                })}
                                            </Layer>
                                        </Stage>
                    </div>
            </Col>
              <Col md={3}>
                  {starPlayer && <Row>
                      <Col>
                          <StorageImage
                              imgKey={
                                  starPlayer.designerIconKey ? starPlayer.designerIconKey :
                                  "planner_icons/planner_" +
                                  starPlayer.name.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") +
                                  "_icon.png"
                              }
                              accessLevel="guest"
                              alt={starPlayer.name}
                              width="50"
                              draggable="true"
                              onDragStart={async (e) => {
                                  try {
                                      const iconKey = starPlayer.designerIconKey
                                          ? starPlayer.designerIconKey
                                          : `planner_icons/planner_${starPlayer.name.toLowerCase().replace(/[\s(),]/g, "_")}_icon.png`
                                      const signedURL = await Storage.get(iconKey, {level: "public"})

                                dragUrl.current = signedURL;
                                dragUrl.plant = starPlayer.name;
                                dragUrl.scale = plantScales[starPlayer.size];

                                console.log("Drag started with image:", dragUrl.current);
                            } catch (error) {
                                console.error("Error fetching image from S3:", error);
                            }
                        }}
                    />
                    <br/>
                <b>{starPlayer.name}</b>
         </Col>
            </Row>}

	{guildPlants.map((plant, pindex) => (
	 <Row>
		<Col>
            <StorageImage
                imgKey={
                    plant.designerIconKey ? plant.designerIconKey :
                    "planner_icons/planner_" +
                    plant.name.toLowerCase().replace(" ", "_").replace("(", "").replace(")", "").replace(",", "_").replace(" ", "_") +
                    "_icon.png"
                }
                accessLevel="guest"
                alt={plant.name}
                width="50"
                draggable="true"
                onDragStart={async (e) => {
                    try {
                        const iconKey = plant.designerIconKey
                            ? plant.designerIconKey
                            : `planner_icons/planner_${plant.name.toLowerCase().replace(/[\s(),]/g, "_")}_icon.png`
                        const signedURL = await Storage.get(iconKey, {level: "public"})

                        dragUrl.current = signedURL;
                        dragUrl.plant = plant.name;
                        dragUrl.scale = plantScales[plant.size];

                        console.log("Drag started with image:", dragUrl.current);
                    } catch (error) {
                        console.error("Error fetching image from S3:", error);
                    }
                }}
            />
            <br/>
	        <b>{plant.name}</b>
	 </Col>
	    </Row>
	))}
  <Row style={{marginTop:"20px"}}>
      <Col>
      <Button
                       onClick={e => { deletePlant()  }}
                       color="danger"
                       className="btn-sm"
                    >
                     Delete
                   </Button>
      </Col>
  </Row>
           </Col>
         </Row>
         <Row>
         <Col md={4}><b>Guild Name</b></Col>
         <Col md={4}>
         <Input type="text" value={guildName} onChange={event => {
                               setGuildName(event.target.value); }}/>
                                <span style={{color:"#FF0000"}}>{errors['guildName']}</span>
          </Col>
          </Row>
          <Row>
          <Col md={4}>


      <Button style={{marginTop: "50px"}}
                       onClick={e => { finishGuild()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Save Guild
                   </Button>

</Col>
</Row>

{showGuild &&
<div><Row style={{marginTop: "20px"}}>
<Col md={10}>


                     <Table className="table-nowrap table-centered mb-0">
                           <thead class="table-dark">
                              <tr>
                              <td>Number of Plants</td>
                              <td>Plant Name</td>
                              <td>Scientific Name</td>
                              <td>Plant Type</td>
                              <td>Size</td>
                              <td>Permaculture Functions</td>
                              <td>Food Forest Layer</td>
                              </tr>
                           </thead>
                           <tbody>
                           <tr>
                              <td>{starPlayer.numPlants}</td>
                              <td>{starPlayer.name}</td>
                              <td><i>{starPlayer['latin name']}</i></td>
                              <td>{starPlayer.season}</td>
                              <td>{starPlayer.size}</td>
                              <td>{starPlayer.guildFunction.map(guild=> (
                                <span>{guild}<br/></span>

                                ))}</td>
                              <td>{starPlayer.foodForestLayer}</td>
                           </tr>
                           {guildPlants.map((plant, pindex) => (
                              <tr>
                              <td>{plant.numPlants}</td>
                              <td>{plant.name}</td>
                              <td><i>{plant['latin name']}</i></td>
                              <td>{plant.season}</td>
                              <td>{plant.size}</td>
                              <td>{plant.guildFunction.map(guild=> (
                                <span>{guild}<br/></span>

                                ))}</td>
                              <td>{plant.foodForestLayer}</td>
                           </tr>
                           ))}
                           </tbody>
                     </Table>
</Col>
</Row>
<Row>
   <Col md={12}><center>
 <Button
                       onClick={e => { saveGuild()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Save Guild To Area
                   </Button>
  </center>
  </Col>
</Row>
</div>

}


                      </TabPane>
                    </TabContent>
                   <ul className="pager wizard twitter-bs-wizard-pager-link">
                      <li
                        className="previous"
                      >
	  {activeTabProgress!=1 && <Link
                          to="#"
                          onClick={() => {
                            toggleTabProgress(activeTabProgress - 1)
                          }}
                        >
                          Previous
                        </Link>}
                      </li>
                      <li className="next">
	  {activeTabProgress!=5 && <Link
                          to="#"
                          onClick={() => {
                            toggleTabProgress(activeTabProgress + 1)
                          }}
                        >
                          Next
                        </Link>}
                      </li>
                    </ul>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>


<Modal isOpen={searchGuild} toggle={() => {
      toggleSearch()
 }}
>
    <ModalHeader tag="h4">
        Search For Guild Plant
    </ModalHeader>
    <ModalBody>
    {guildFunction && <Row><Col md={6}><b>Guild Function: </b></Col><Col md={6}>{guildFunction}</Col></Row>}
    {layer && <Row><Col md={6}><b>Layer: </b></Col><Col md={6}>{layer}</Col></Row>}
	{!guildFunction && !layer && <Row>
              <Col md={6}><b>Function</b></Col>
              <Col md={6}>
                  <Input type="select" value={guildFunction} onChange={event => {
                      setGuildFunction(event.target.value);
                  }}>
                      <option value=""></option>
                      <option value="Erosion Control">Erosion Control</option>
                      <option value="Windbreak / Privacy">Windbreak/Privacy</option>
                      <option value="Pollinator / Insectary">Pollinator/Insectary</option>
                      <option value="Food / Fiber">Food/Fiber</option>
                      <option value="Habitat">Habitat</option>
                      <option value="Medicinal">Medicinal</option>
                      <option value="Dynamic Accumulator">Dynamic Accumulator</option>
                      <option value="Nitrogen Fixer">Nitrogen Fixer</option>
                  </Input>
              </Col>
    </Row>}
        <Row>
            <Col md={6}><b>Climate</b></Col>
              <Col md={6}>
                  <Input type="select" value={climate} onChange={event => {
                      setClimate(event.target.value);
                  }}>
                      <option value="">All</option>
                      <option value="Subtropical">Subtropical</option>
                      <option value="Tropical">Tropical</option>
                      <option value="Temperate">Temperate</option>
                      <option value="Mediterranean">Mediterranean</option>
                      <option value="Cold Desert">Cold Desert</option>
                      <option value="Hot Desert">Hot Desert</option>
                      <option value="Cool Temperate">Cool Temperate</option>
                  </Input>
              </Col>
         </Row>
        <Row>
            <Col md={6}><b>USDA Zone</b></Col>
              <Col md={6}>
                    <Input type="select" value={zone} onChange={event => {
                               setZone(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="1">1a-1b</option>
                          <option value="2">2a-2b</option>
                          <option value="3">3a-3b</option>
                    <option value="4">4a-4b</option>
                          <option value="5">5a-5b</option>
                          <option value="6">6a-6b</option>
                          <option value="7">7a-7b</option>
                          <option value="8">8a-8b</option>
                          <option value="9">9a-9b</option>
                    <option value="10">10a-10b</option>
                          <option value="11">11a-11b</option>
                          <option value="12">12a-12b</option>
                    </Input>
              </Col>
         </Row>
         {!layer && <Row>
              <Col md={6}><b>Layer</b></Col>
              <Col md={6}>
                    <Input type="select" value={layer} onChange={event => {
                               setLayer(event.target.value);
                          }}>
                          <option value=""></option>
                          <option value="Canopy">Canopy</option>
                          <option value="Subcanopy">Subcanopy</option>
                          <option value="Shrub">Shrub/Bush</option>
                          <option value="Herbaceous">Herbaceous</option>
                          <option value="Ground Cover">Ground Cover</option>
                          <option value="Root Crop">Root Crop</option>
                    <option value="Vining">Vining</option>
                    </Input>
              </Col>
         </Row>
       }

         <Row style={{ paddingTop: "10px", paddingBottom: "10px"}}>
              <Col md="4"/>
              <Col md="2">
                   <Button
                       onClick={e => { submitSearch()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Search
                   </Button>

              </Col>

            </Row>
    <div style={{width: "100%",height: "200px",overflowX:"hidden",overflowY:"scroll"}}>
    <Row>
    {userGuildResults && userGuildResults.map((plant) => (
      <Col md={6}>

  <Card outline color="secondary" className="border">
     <CardBody  style={{margin:"5px", padding:"2px", border:"2px"}} >
        <Row>
            <Col>
                <StorageImage
                    alt={plant.name}
                    imgKey={plant.cardIconKey ? plant.cardIconKey : "card_icons/" + plant.name.toLowerCase().replace(" ","_").replace("(","").replace(")","").replace(",","_").replace(" ","_")+".png"}
                    accessLevel="guest"
                    onStorageGetError={(error) => console.error(error)}
                    style={{ width: "100%", height: "auto", maxWidth: "324px", display: "block", margin: "auto" }}
                />
            </Col>
        </Row>
         <Row>
            <Col md={8}><i>{plant.name}</i></Col>
       <Col md={3}>
                   <center><Button
                       onClick={e => { addGuildPlant(plant)  }}
                       color="primary"
                       className="btn-sm"
                    >
                     Add
                   </Button></center>
                  </Col>
       <Col md={1}/>
        </Row>
   <Row>
            <Col><b>Layer:</b> {plant.foodForestLayer}</Col>
        </Row>
   <Row>
            <Col><b>Zone:</b> {plant.USDAMin} - {plant.USDAMax}</Col>
        </Row>
        <Row>
            <Col><b>Climate:</b> {plant.climate}</Col>
        </Row>
     <Row>
            <Col><b>Functions:</b> <ul>{plant.guildFunction.map((guild) => (
             <li>{guild}</li>
      ))} </ul>
      </Col>
        </Row>


      </CardBody>
  </Card>
        </Col>
          ))}
        </Row>
    </div>
    </ModalBody>
</Modal>


    </React.Fragment>
  )
}

const mapStateToProps = (state, ownProps) => {
  console.log("guildbuilder_dataload")
     const sortedPlants = state.designer.plants.sort((a, b) => (a.name > b.name) ? 1 : -1);
  return ({
  userareas: state.goals.areas,
  profile: state.Profile.user,
  plantData: state.designer.plants,
  guildResults: state.goals.plants.sort((a, b) => (a.name > b.name) ? 1 : -1),
  plantDataMap: sortedPlants.reduce((map, obj) => (map[obj.name] = obj, map), {}),
  customplants: state.goals.customplants,
  })
}


const mapDispatchToProps = dispatch => ({
  onGetProfile: (username) => dispatch (getProfile(username)),
  onGetPlantData: () => dispatch(getPlantData()),
  onSearchGuild: searchGuildParams => dispatch(searchGuild(searchGuildParams)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BuildGuild)


